<template>
    <div :style="`width:${size}px; height:${size}px;`">
        <svg version="1.1" viewBox="0 0 512 512" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <g v-for="(heart, index) in hearts" :key="`animated-hearts-${index}`">
                <path d="M365.4,59.628c60.56,0,109.6,49.03,109.6,109.47c0,109.47-109.6,171.8-219.06,281.271    C146.47,340.898,37,278.568,37,169.099c0-60.44,49.04-109.47,109.47-109.47c54.73,0,82.1,27.37,109.47,82.1    C283.3,86.999,310.67,59.628,365.4,59.628z" style="fill:#FF7979;"/>
                <animateTransform attributeName="transform" attributeType="XML" type="translate" :from="`${heart.leftStarts} ${heart.topStarts}`" :to="`${heart.leftEnds} ${heart.topEnds}`" :dur="`${heart.duration}s`" repeatCount="indefinite" additive="sum" />
                <animateTransform attributeName="transform" attributeType="XML" type="scale" from="0" :to="heart.scale" :dur="`${heart.duration}s`" repeatCount="indefinite" additive="sum" />
                
                <animate attributeName="opacity" values="0;1;1;0" :dur="`${heart.duration}s`" repeatCount="indefinite" />
            </g>
        </svg>
    </div>
</template>

<script type="text/javascript">
    import Utilities from '@/classes/Utilities.js';

    export default {
        props: {
            size: {
                type: Number,
                default: 512,
            },
        },
        computed: {
            hearts() {
                let count = Utilities.random(10, 20);
                let re = [];

                for (let i=0; i<count; i++) {

                    re.push({
                        duration: Utilities.random(1, 3),
                        leftStarts: Utilities.random(400, 500),
                        leftEnds: Utilities.random(0, 200),
                        topStarts: Utilities.random(400, 500),
                        topEnds: Utilities.random(0, 200),
                        scale: Utilities.random(10, 50) / 100,
                    });
                }

                return re;
            },
        },

    };

</script>
